// extracted by mini-css-extract-plugin
export default {"cont":"customDropdownitem_cont__E8UW2","clickable":"customDropdownitem_clickable__yB5mn","nonClickable":"customDropdownitem_nonClickable__TVAQB"};